import { apiFetch } from './client';
import {
    TenantPaymentSetting,
    TenantPaymentSettingsResponse,
    TenantPaymentSettingsUpdatePayload,
} from '../types/payment';

interface ApiError extends Error {
    status?: number;
    payload?: unknown;
}

async function handleResponse<T>(res: Response): Promise<T> {
    if (res.ok) {
        if (res.status === 204) {
            return undefined as T;
        }
        const text = await res.text();
        if (!text) {
            return {} as T;
        }
        try {
            return JSON.parse(text) as T;
        } catch (parseErr) {
            console.error('Impossibile decodificare la risposta JSON', parseErr);
            throw new Error('Risposta inattesa dal server');
        }
    }

    const errorText = await res.text();
    const error: ApiError = new Error(errorText || 'Errore nella chiamata API');
    error.status = res.status;
    if (errorText) {
        try {
            error.payload = JSON.parse(errorText);
        } catch (parseErr) {
            error.payload = errorText;
        }
    }
    throw error;
}

export async function fetchPaymentSettings(pin: string): Promise<TenantPaymentSettingsResponse> {
    const res = await apiFetch('/api/tenant/payment-settings', {
        method: 'GET',
        headers: {
            'X-Payment-Pin': pin,
        },
    });
    return handleResponse<TenantPaymentSettingsResponse>(res);
}

export async function updatePaymentSettings(pin: string, payload: TenantPaymentSettingsUpdatePayload): Promise<TenantPaymentSettingsResponse> {
    const res = await apiFetch('/api/tenant/payment-settings', {
        method: 'PUT',
        headers: {
            'X-Payment-Pin': pin,
        },
        body: JSON.stringify(payload),
    });
    return handleResponse<TenantPaymentSettingsResponse>(res);
}

export type { TenantPaymentSetting };
